import { AutoSuggestItem, AutoSuggestOptions } from './Types';

// used by Downshift to convert objects into friendly text to display to users.
// can be overridden as necessary.
export const itemToString = (item: AutoSuggestItem) => {
	if (!item) {
		return '';
	}

	return item ? item.label : '';
};

class AutoSuggestOptionsError extends Error {}

/**
 * Ensures that the provided autoSuggestOptions are valid. There are some invalid configurations and this helps prevent
 * them from causing unexpected behavior.
 * @param autoSuggestOptions
 */
export const assertValidAutoSuggestOptions = (autoSuggestOptions: AutoSuggestOptions) => {
	if (!autoSuggestOptions) {
		throw new AutoSuggestOptionsError('AutoSuggest Options are required.');
	}

	const hasStaticDataOption =
		Array.isArray(autoSuggestOptions.staticData) && autoSuggestOptions.staticData.length > 0;

	if ((!autoSuggestOptions.baseUrl && !hasStaticDataOption) || (autoSuggestOptions.baseUrl && hasStaticDataOption)) {
		throw new AutoSuggestOptionsError('Either provide a baseUrl or a staticData option, but not both or neither.');
	}

	if (hasStaticDataOption && autoSuggestOptions.allowNewValues) {
		throw new AutoSuggestOptionsError('New values cannot be created when static data is provided.');
	}
};

/**
 * Helper function to reorder items in an array
 * @param list
 * @param startIndex
 * @param endIndex
 */
export const reorderArrayValues = <T,>(list: T[], startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
};
